import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';

const defaultOutcomeConfig = {
  [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
  [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
};

const successOnlyConfig = {
  [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
};

export const cardManagementNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> =
  new Map([
    [ButtonActionType.SECURE_CVV_DETAILS, defaultOutcomeConfig],
    [ButtonActionType.CANCEL_CARD, defaultOutcomeConfig],
    [ButtonActionType.SET_CARD_NAME, defaultOutcomeConfig],
    [ButtonActionType.SHOW_PIN, defaultOutcomeConfig],
    [ButtonActionType.REFRESH_CARDS_AND_REDIRECT, successOnlyConfig],
    [ButtonActionType.GET_SENSITIVE_CARD_DETAILS, defaultOutcomeConfig],
    [ButtonActionType.ADD_CARD, defaultOutcomeConfig],
    [ButtonActionType.ACTIVATE_CARD, defaultOutcomeConfig],
  ]);
